import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";

import { AppComponent } from "./app.component";
import { routes } from "./app.routes";
import { LoginModule } from "./login/login.module";
import { PrivateModule } from "./private/private.module";
import {
  JwtService,
  ApiService,
  UserService,
  AuthGuard,
  DashboardService,
} from "./shared/services";
import { SharedModule } from "./shared/shared.module";
import { NgbDateParserFormatterUtility } from "./shared/common/tools/ngbdateparser-formatter.utility";
import { AssociationService } from "./shared/services/association.service";
import { StudentsForImpactService } from './shared/services/students-for-impact.service';
import { InvoiceService } from './shared/services/invoice.service';
import { CagnotteService } from "./shared/services/cagnotte.service";
import { CategoryAssociationsService } from "./shared/services/category-associations.service";
import { CountryService } from "./shared/services/country.service";
import { PartenaireService } from "./shared/services/partenaire.service";
import { CommonModule } from "@angular/common";
import { NgbModule, NgbDateParserFormatter } from "@ng-bootstrap/ng-bootstrap";
import { ToastyModule } from "ng2-toasty";
import { TypeEventService } from "./shared/services/type-event.service";
import { ModalModule, BsDatepickerModule } from "ngx-bootstrap";
import { DonationService } from "./shared/services/donation.service";
import { DocumentService } from "./shared/services/documents.service";
import { SubscriptionService } from "./shared/services/subscription.service";
import { SeekerService } from "./shared/services/seeker.service";
import { PotService } from "./shared/services/pot.service";
import { ImageCropperModule } from "ngx-image-cropper";
import { ImageUploadModule } from "angular2-image-upload";
import { AssociationTypeService } from "./shared/services/assoc-type.service";
import { QuillModule } from "ngx-quill";
import { NewsletterService } from "./shared/services/newsletter.service";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";

@NgModule({
  declarations: [AppComponent],
  imports: [
    CommonModule,
    BrowserModule,
    SharedModule,
    ImageCropperModule,
    QuillModule.forRoot(),
    ImageUploadModule.forRoot(),
    RouterModule.forRoot(routes),
    NgbModule,
    ModalModule.forRoot(),
    ToastyModule.forRoot(),
    BsDatepickerModule.forRoot(),
    TypeaheadModule.forRoot(),
    LoginModule,
    PrivateModule,
  ],
  providers: [
    {
      provide: NgbDateParserFormatter,
      useFactory: parser,
    },
    ApiService,
    AuthGuard,
    JwtService,
    UserService,
    SeekerService,
    AssociationService,
    StudentsForImpactService,
    InvoiceService,
    DonationService,
    SubscriptionService,
    DocumentService,
    CagnotteService,
    PartenaireService,
    CategoryAssociationsService,
    TypeEventService,
    CountryService,
    PotService,
    AssociationTypeService,
    DashboardService,
    NewsletterService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }

export function parser() {
  return new NgbDateParserFormatterUtility("yyyy-MM-dd");
}
